function num(a: any, b: any): number {
    return (a !== undefined && a !== null) ? a : (b || 0);
}

export class ChatIaConfigDto {
    public id: number = 0;
    public idCliente: number = 0;
    public nombre: string = "";
    public invokeUrl: string = "https://integrate.api.nvidia.com/v1/chat/completions";
    public apiKey: string = "";
    public modelo: string = "nvidia/nemotron-mini-4b-instruct";
    public maxTokens: number = 8192;
    public temperature: number = 1.0;
    public topP: number = 0.95;
    public activo: boolean = true;
    public promptBase: string = "";

    constructor(data?: any) {
        if (!data) { return; }
        this.id          = num(data.Id,          data.id);
        this.idCliente   = num(data.Id_cliente,  data.id_cliente);
        this.nombre      = data.Nombre      || data.nombre      || "";
        this.invokeUrl   = data.InvokeUrl   || data.invokeUrl   || data.Invoke_url || data.invoke_url || "https://integrate.api.nvidia.com/v1/chat/completions";
        this.apiKey      = data.ApiKey      || data.apiKey      || data.Api_key    || data.api_key    || "";
        this.modelo      = data.Modelo      || data.modelo      || "nvidia/nemotron-mini-4b-instruct";
        this.maxTokens   = num(data.MaxTokens, data.maxTokens) || num(data.Max_tokens, data.max_tokens) || 8192;
        this.temperature = num(data.Temperature, data.temperature) || 1.0;
        this.topP        = num(data.TopP, data.topP) || num(data.Top_p, data.top_p) || 0.95;
        this.activo      = data.Activo !== undefined ? data.Activo : (data.activo !== undefined ? data.activo : true);
        this.promptBase  = data.PromptBase || data.promptBase || data.Prompt_base || data.prompt_base || "";
    }

    public toJson(): object {
        return {
            id:          this.id,
            id_cliente:  this.idCliente,
            nombre:      this.nombre,
            invoke_url:  this.invokeUrl,
            api_key:     this.apiKey,
            modelo:      this.modelo,
            max_tokens:  this.maxTokens,
            temperature: this.temperature,
            top_p:       this.topP,
            activo:      this.activo,
            prompt_base: this.promptBase || null
        };
    }
}
